import { Button, Popover } from '@heroui/react'

/**
 * A row-level "?" that opens its explanation ON CLICK, pinned until dismissed.
 * A native tooltip cannot be screenshotted, does not exist on a touch screen,
 * and takes a second to appear, which reads as nothing happening.
 */
const HelpMark = ({ text }: { text?: string | null }) => {
  if (!text) return null

  return (
    <Popover>
      <Button
        isIconOnly
        size="sm"
        variant="ghost"
        aria-label="Explain this row"
        className="border-border ml-1 size-[18px] min-w-0 rounded-full border text-[11px] font-semibold"
      >
        ?
      </Button>
      <Popover.Content className="max-w-80" placement="bottom">
        <Popover.Dialog>
          <Popover.Arrow />
          <p className="text-sm leading-relaxed">{text}</p>
        </Popover.Dialog>
      </Popover.Content>
    </Popover>
  )
}

export default HelpMark
